import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
// `index.css` is a 622 KB *pre-compiled* Tailwind dump committed to the repo. It
// contains no @tailwind directives, so the JIT does not run: a utility class only
// has a rule if it happened to be in use the day that snapshot was generated.
// Anything newer silently resolves to nothing, which is why inline styles are used
// as a workaround throughout the codebase.
//
// The live source chain (assets/styles/app.css -> tailwind/index.css) was wired up
// in f5b23121 and is reverted here: switching the JIT on activated utilities that
// had been sitting dead in the code for months, changing rendering in places nobody
// had touched — e.g. `lg:h-[500px]` on the proposal title slide started applying
// and made long overviews overlap the next section, and `object-cover` began
// cropping the cover artwork. Re-enabling it needs a pass over every dormant class,
// not a one-line import.
//
// So: before adding a utility class, check it has a rule in index.css. If not, use
// an inline style.
import './index.css'
import App from './App'
import AppErrorBoundary from 'components/errors/AppErrorBoundary'
import reportWebVitals from './reportWebVitals'

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development',
    enabled: !!process.env.REACT_APP_SENTRY_DSN,
    tracesSampleRate: 0.2,
    integrations: [Sentry.browserTracingIntegration()],
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
    <React.StrictMode>
        <AppErrorBoundary>
            <App />
        </AppErrorBoundary>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
